'use client'

import { Box, Spinner } from '@chakra-ui/react'
import { MedicalSurveyForm, SurveyHistoryList } from '@/features/medical-survey'
import { EDonorStatusStep } from '@/entities/donor/model'
import {
  useGetDonorCardDetailQuery,
  useGetDonorDetailQuery,
} from '@/entities/donor/api/get-donor.api'
import {
  hasActiveStep,
  isDonorCardReadOnly,
} from '../model/use-donor-card-read-only'

interface Props {
  visitId: string
}

export function MedicalSurveyTab({ visitId }: Props) {
  const { data: donor } = useGetDonorDetailQuery(visitId)
  const { data: donorCard, isPending: donorCardLoading } =
    useGetDonorCardDetailQuery(donor?.donor_id ?? '')

  if (donorCardLoading) {
    return (
      <Box display="flex" justifyContent="center" py={10}>
        <Spinner size="lg" color="primary.fg" />
      </Box>
    )
  }

  // While the survey is the active step it stays editable; once the donor has
  // moved past registration, the visit is finished (`step = null`), or the
  // donor isn't admitted, we show the read-only survey history instead.
  if (
    isDonorCardReadOnly(donorCard) ||
    !hasActiveStep(donorCard, EDonorStatusStep.REGISTRATION)
  ) {
    return <SurveyHistoryList donorId={donor?.donor_id ?? ''} />
  }

  return <MedicalSurveyForm visitId={visitId} />
}
